import { useState, useEffect } from 'react';
import { getGremios } from '../../modules/apps/user-management/users-list/core/_requests';

export interface GremioModel {
  id: number;
  nombre: string;
  codigo: string | null;
}

const useGremiosParams = () => {
  const [gremiosList, setGremiosList] = useState<GremioModel[]>([]);
  const [loadingGremios, setLoadingGremios] = useState<boolean>(true);

  useEffect(() => {
    const fetchGremios = async () => {
      try {
        setLoadingGremios(true);
        const response = await getGremios();
        if (response && response.data) {
          setGremiosList(response.data);
        }
      } catch (error: any) {
        console.error('Error al cargar gremios:', error);
      } finally {
        setLoadingGremios(false);
      }
    };

    fetchGremios();
  }, []);

  return {
    gremiosList,
    loadingGremios,
  };
};

export default useGremiosParams;